import React from 'react';
import { Box, HStack, Spacer, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  initStateData,
  SetMessageData
} from '../../../redux/message/MessageSlice';

export const MessageHeader: React.FC = () => {
  const dispatch = useDispatch();
  return (
    <HStack h={12} bgColor='gray.800' color='white'>
      <Text mr={10} color='silver' ml='10' fontSize='16'>
        OBCメッセージ／電停メッセージ送信
      </Text>
      <Spacer />
      <Box
        textAlign='right'
        fontSize='14'
        bg='transparent'
        _hover={{ bg: 'gray', color: 'white' }}
        color='silver'
        onClick={() => {
          dispatch(SetMessageData({ data: initStateData }));
        }}
      >
        <Link to='/location'>閉じる</Link>
      </Box>
    </HStack>
  );
};
